
import { metaData } from '~/configuration/metaData';
import { CMSService } from '~/services/storyBlok/cmsService';
import { selectFCBaseProduct } from '~/selectors/selectors';
import { transformPackageProduct } from '~/utils/transformers';
import PackagePage from '~/components/v2/pdps/PackagePage.vue';

export default {
  name: 'FightCampConsole',
  head: {
    ...metaData.consoleStarter,
  },
  components: {
    PackagePage,
  },
  data() {
    return {
      transformedPackageProduct: {},
      reviews: [],
    };
  },
  provide() {
    return {
      packageData: computed(() => this.transformedPackageProduct),
    };
  },
  async asyncData({
    $storyapi, error, store,
  }) {
    const storyBlok = new CMSService({ cmsService: $storyapi });

    try {
      // TODO move from storyblok
      const resp = await storyBlok.get('fc-products/console-starter', { resolve_relations: 'ProductData.ecommerceProducts' });
      const packageData = resp?.data?.story;
      const cmsContent = selectFCBaseProduct(packageData);
      const eCommContent = store.getters.productsCollection;
      const transformedPackageProduct = transformPackageProduct({ cmsContent, eCommContent });

      // get the reviews
      const reviews = await storyBlok.getAll('user-reviews');

      return { reviews, transformedPackageProduct };
    } catch (e) {
      error({ message: e.message });
      return {};
    }
  },
};
